import React, { useState } from 'react';
import { X, ZoomIn } from 'lucide-react';
import styles from './form.module.css';

/** Participant-facing question image with tap-to-zoom. Used in MC, OpenText, RatingScale, Categories, CorrectOrder forms. */
export default function ParticipantQuestionImage({ imageUrl, alt = 'Question visual' }) {
    const [zoomOpen, setZoomOpen] = useState(false);
    if (!imageUrl) return null;
    return (
        <>
            <div
                className={styles.questionImageWrap}
                onClick={() => setZoomOpen(true)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && setZoomOpen(true)}
                aria-label="Tap to zoom image"
            >
                <img src={imageUrl} alt={alt} className={styles.questionImage} />
                <span className={styles.zoomHint} aria-hidden>
                    <ZoomIn size={14} /> Tap to zoom
                </span>
            </div>
            {zoomOpen && (
                <div
                    className={styles.imageZoomOverlay}
                    onClick={() => setZoomOpen(false)}
                    role="dialog"
                    aria-modal="true"
                    aria-label="Zoomed image"
                >
                    <div
                        className={styles.imageZoomModal}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            type="button"
                            className={styles.imageZoomClose}
                            onClick={() => setZoomOpen(false)}
                            aria-label="Close zoom"
                        >
                            <X size={18} />
                        </button>
                        <img
                            src={imageUrl}
                            alt={`${alt} (zoomed)`}
                            className={styles.imageZoomImg}
                        />
                    </div>
                </div>
            )}
        </>
    );
}
